var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48593",
    "data-name": "Group 48593",
    transform: "translate(-983 -657)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138031",
    "data-name": "Rectangle 138031",
    width: 24,
    height: 24,
    transform: "translate(983 657)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48573",
    "data-name": "Group 48573",
    transform: "translate(-20.75 -20.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93206",
    "data-name": "Path 93206",
    d: "M20.75,10.23v2.52c0,3.5-2,5-5,5h-10c-3,0-5-1.5-5-5v-7c0-3.5,2-5,5-5h10c3,0,5,1.5,5,5Z",
    transform: "translate(1005 681)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93207",
    "data-name": "Path 93207",
    d: "M15.75,6.25l-3.13,2.5a3.166,3.166,0,0,1-3.75,0L5.75,6.25",
    transform: "translate(1005 681)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.e1e8f566205433b4a401e9ba1cb31adc.svg";
export { ForwardRef as ReactComponent };